<template>
  <Modal v-model="open" :content-class="'max-w-2xl'" show-close>
    <template #title>{{ t('title') }}</template>

    <ul
      v-if="links.length"
      class="divide-y divide-obsidian-100 overflow-hidden rounded-lg border border-obsidian-100"
    >
      <li
        v-for="href in links"
        :key="href"
        class="flex items-center justify-between gap-3 bg-white px-4 py-3 text-sm"
      >
        <a
          :href="href"
          class="min-w-0 break-all text-primary underline"
          target="_blank"
          rel="noopener"
        >
          {{ href }}
        </a>
        <CopyToClipboardButton :text="href" class="shrink-0 text-obsidian-500" />
      </li>
    </ul>

    <p v-else class="text-sm text-obsidian-500">
      {{ t('missingWebsiteUrls') }}
    </p>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import Modal from '@/components/Modal.vue';
import CopyToClipboardButton from '@/components/CopyToClipboardButton.vue';
import { WEBSITE_URLS } from '@/constants/website-urls.constant';

const props = defineProps<{
  code: string;
}>();

const open = defineModel<boolean>({ required: true });

const { t } = useI18n();

const links = computed(() =>
  (WEBSITE_URLS ?? '')
    .split(',')
    .map((part) => part.trim())
    .filter(Boolean)
    .map((baseUrl) => {
      const url = new URL(baseUrl);
      url.searchParams.set('promoCode', props.code);
      return url.toString();
    }),
);
</script>

<i18n lang="json">
{
  "en": {
    "title": "Promo coupon links",
    "missingWebsiteUrls": "Website URLs are not configured."
  },
  "de": {
    "title": "Gutschein-Links",
    "missingWebsiteUrls": "Website-URLs sind nicht konfiguriert."
  },
  "es": {
    "title": "Enlaces del cupón promocional",
    "missingWebsiteUrls": "Las URLs del sitio web no están configuradas."
  }
}
</i18n>
